import React from 'react';
import { Box } from '@mui/material';
import ImageBoxCard from '../../ImageBoxCard/ImageBoxCard';

/** Matches ImageBoxCard's own maxWidth. A column wider than this just pads the card with air. */
const CARD_WIDTH_PX = 250;

const CardGrid = ({ data = [], columns = 4, rows = 2, gap = 2, centerIncompleteRow = false }) => {
    const visibleData = data.slice(0, columns * rows);

    if (centerIncompleteRow) {
        const gapPx = typeof gap === "number" ? gap * 8 : 16;
        const maxWidthPx = columns * CARD_WIDTH_PX + (columns - 1) * gapPx;

        return (
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    gap,
                    width: "100%",
                    maxWidth: `${maxWidthPx}px`,
                    my: 4,
                }}
            >
                {visibleData.map((card, i) => (
                    <Box key={i} sx={{ flex: `0 0 ${CARD_WIDTH_PX}px`, display: "flex", justifyContent: "center" }}>
                        <ImageBoxCard
                            title={card.title}
                            img={card.img}
                            href={card.href}
                            onClick={card.onClick}
                            badge={card.badge}
                            active={card.active}
                        />
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    // Capped at the card's own width rather than 1fr. With 1fr the columns absorbed
                    // whatever width the grid was given, and the grid sits in a flex column with
                    // alignItems:'center' — so its width came from the widest SIBLING on the page.
                    // Opening a wide panel below (Home's Recommendations) made the parent grow and
                    // the tiles above drift apart at the moment of the click. minmax keeps the
                    // shrink-to-fit behaviour that 1fr gave on narrow screens: below roughly
                    // columns * 250px the tracks still compress instead of overflowing.
                    md: `repeat(${Math.min(columns, data.length)}, minmax(0, ${CARD_WIDTH_PX}px))`,
                },
                gridAutoRows: 'auto',
                gap,
                width: '100%',
                my: 4,
                // The tracks no longer fill the row, so this now actually does something: it keeps
                // the group centred instead of hugging the left edge.
                justifyContent: 'center',
                alignItems: 'flex-start',
            }}
        >
            {visibleData.map((card, i) => (
                <ImageBoxCard
                    key={i}
                    title={card.title}
                    img={card.img}
                    href={card.href}
                    onClick={card.onClick}
                    state={card.state}
                    badge={card.badge}
                    active={card.active}
                />
            ))}
        </Box>
    );
};

export default CardGrid;
